import React from 'react'
import PropTypes from 'prop-types'

const styles = {
    col1: {
        fill: '#28AAE1',
        fillRule: 'nonzero',
    },
}

const exitDoSVG = ({ classes, color, width, height }) => (
    <svg viewBox="0 0 24 24" width={width} height={height}>
                <g>
                    <path
                        d=" M 4.894 16.832 C 5.237 16.832 5.674 17.424 5.674 18.173 C 5.674 18.921 5.237 19.482 4.894 19.482 C 4.52 19.482 4.084 18.921 4.084 18.173 C 4.084 17.424 4.52 16.832 4.894 16.832 Z  M 4.894 16.271 L 4.894 16.271 C 4.115 16.271 3.492 17.113 3.492 18.173 C 3.492 19.201 4.115 20.074 4.894 20.074 C 5.643 20.074 6.266 19.201 6.266 18.173 C 6.266 17.113 5.643 16.271 4.894 16.271 Z "
                        style={ styles.col1 }/>
                    <path d=" M 7.7 19.95 L 6.827 19.95 L 6.827 16.396 L 7.7 16.396 L 7.7 19.95 Z "
                          style={ styles.col1 }/>
                    <path d=" M 9.415 19.95 L 8.542 19.95 L 8.542 16.396 L 9.415 16.396 L 9.415 19.95 Z "
                          style={ styles.col1 }/>
                    <path d=" M 16.367 19.95 L 15.463 19.95 L 15.463 16.396 L 16.367 16.396 L 16.367 19.95 Z "
                          style={ styles.col1 }/>
                    <path d=" M 2.775 19.95 L 1.902 19.95 L 1.902 16.396 L 2.775 16.396 L 2.775 19.95 Z "
                          style={ styles.col1 }/>
                    <path d=" M 14.683 19.95 L 13.811 19.95 L 13.811 16.396 L 14.683 16.396 L 14.683 19.95 Z "
                          style={ styles.col1 }/>
                    <path
                        d=" M 11.691 16.832 C 12.065 16.832 12.47 17.424 12.47 18.173 C 12.47 18.921 12.065 19.482 11.691 19.482 C 11.317 19.482 10.88 18.921 10.88 18.173 C 10.88 17.424 11.317 16.832 11.691 16.832 Z  M 11.691 16.271 L 11.691 16.271 C 10.911 16.271 10.288 17.113 10.288 18.173 C 10.288 19.201 10.911 20.074 11.691 20.074 C 12.439 20.074 13.062 19.201 13.062 18.173 C 13.062 17.113 12.439 16.271 11.691 16.271 Z "
                        style={ styles.col1 }/>
                </g>
                <path
                    d=" M 19.703 7.978 L 19.703 5.921 L 23.787 8.571 L 19.703 11.221 L 19.703 9.163 L 6.484 9.163 L 6.484 15.086 L 5.3 15.086 L 5.3 7.978 L 19.703 7.978 Z "
                    style={ styles.col1 }/>
                <g>
                    <path d=" M 17.333 21.415 L 18.3 21.415 L 18.3 10.504 L 17.333 10.504 L 17.333 21.415 Z "
                          style={{ fill: color }}/>
                    <path
                        d=" M 0 2.086 L 0 21.415 L 0.998 21.415 L 0.998 3.084 L 17.333 3.084 L 17.333 6.544 L 18.3 6.544 L 18.3 2.086 L 0 2.086 Z "
                        style={{ fill: color }}/>
                </g>
                <path d=" M 18.331 21.914 L 0 21.914 L 0 20.916 L 18.331 20.916 L 18.331 21.914 Z "
                      style={{ fill: color }}/>
    </svg>
)

exitDoSVG.defaultProps = {
    color: '#fff',
    width: 24,
    height: 24,
}

exitDoSVG.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default exitDoSVG
